import { useState } from 'react';

export function useScrollControl(scrollContainerRef: React.RefObject<HTMLDivElement | null>) {
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [canScrollRight, setCanScrollRight] = useState(false);

	const updateScrollState = () => {
		if (!scrollContainerRef.current) return;

		const container = scrollContainerRef.current;
		const isAtStart = container.scrollLeft <= 0;
		const isAtEnd = container.scrollLeft >= container.scrollWidth - container.clientWidth;

		setCanScrollLeft(!isAtStart);
		setCanScrollRight(!isAtEnd);
	};

	/**
	 * Scrolls the container by exactly one card width in the specified direction.
	 */
	const scrollByOneCard = (direction: 'left' | 'right') => {
		if (!scrollContainerRef.current) return;

		const container = scrollContainerRef.current;
		const firstCard = container.querySelector<HTMLElement>('[data-platform]');
		if (!firstCard) return;

		// Calculate card width including gap
		const cardWidth = firstCard.offsetWidth;
		const gap = 16; // gap-4 = 1rem = 16px
		const scrollDistance = cardWidth + gap;

		const newScrollPosition =
			direction === 'left' ? container.scrollLeft - scrollDistance : container.scrollLeft + scrollDistance;

		container.scrollTo({
			left: newScrollPosition,
			behavior: 'smooth',
		});
	};

	return {
		canScrollLeft,
		canScrollRight,
		updateScrollState,
		scrollByOneCard,
	};
}
